import {
  getV1CompaniesCompanyIdSettlementsSettlementIdSettlementLineItems,
  GetV1CompaniesCompanyIdSettlementsSettlementIdSettlementLineItemsData,
  SettlementLineItemType,
} from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import { useCallback, useState } from 'react';

import connection from '~services/connectionModule';
import { useStores } from '~store';

import { SettlementLineItemGroup, SettlementPresentation } from './models';

export default function useSettlementLineItems() {
  const [isLoading, setIsLoading] = useState(false);
  const { settlementLineItemsStore } = useStores();

  const getAllSettlementLineItems = useCallback(
    async (
      companyId: string,
      settlementId: string,
      settlementLineItemType?: SettlementLineItemType,
    ) => {
      setIsLoading(true);

      try {
        const query: GetV1CompaniesCompanyIdSettlementsSettlementIdSettlementLineItemsData['query'] =
          {};

        if (settlementLineItemType) {
          query['settlement_line_item_type'] = settlementLineItemType;
        }

        const response =
          await getV1CompaniesCompanyIdSettlementsSettlementIdSettlementLineItems({
            path: { 'settlement-id': settlementId, 'company-id': companyId },
            query,
          });

        const parsedResponse = response.data.data.map((lineItem) => {
          return SettlementLineItemGroup.parse(lineItem);
        });

        settlementLineItemsStore.setSettlementLineItemGroupsBySettlementId(
          settlementId,
          parsedResponse,
        );
        settlementLineItemsStore.setPresentationBySettlementId(
          settlementId,
          SettlementPresentation.parse(response.data.presentation),
        );

        return parsedResponse;
      } catch (error) {
        console.error(error);
        connection.handleRequestError(
          error,
          t('error_messages.settlements.failed_to_fetch_line_items'),
        );
        return [];
      } finally {
        setIsLoading(false);
      }
    },
    [settlementLineItemsStore],
  );

  return { getAllSettlementLineItems, isLoading };
}
